import { Component, OnInit, Input, ViewEncapsulation,/* , PLATFORM_ID, Inject */ 
OnDestroy,
Inject,
PLATFORM_ID,
Renderer2} from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { CustomDeviceDetectorService } from '../../services/custom-device-detector.service';
import { BreadcrumbData } from '../breadcrumb/breadcrumb.component';
import { ApiService } from '../../services/api.service';
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';
import { PageMetaComponentBase } from '../../page-meta-component-base';
import { DOCUMENT } from '@angular/common';
// import { isPlatformServer } from '@angular/common';

@Component({
  selector: 'app-blog-gallery',
  templateUrl: './blog-gallery.component.html',
  styleUrls: ['./blog-gallery.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BlogGalleryComponent extends PageMetaComponentBase implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering =null;;
  public isMobile: boolean;
  breadcrumbData = {} as BreadcrumbData;
  blogs : any[] = [];

  // private itemId:string;
  // _isPlatformServer: boolean = false;
  public contextSubscription: Subscription;
  language:string;

  constructor( protected apiService: ApiService, private deviceDetector: CustomDeviceDetectorService, @Inject(PLATFORM_ID) public readonly platformId: string, private jssContext: JssContextService, public renderer: Renderer2,@Inject(DOCUMENT) public document: Document) { super(renderer, platformId, document) }

  ngOnInit() {
    // this._isPlatformServer = isPlatformServer(this.platformId);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language
    });
    let fields = this.rendering?.fields as any;
    this.breadcrumbData.items =(this.rendering?.fields?.result as any)?.['BreadcrumbData'];
    this.isMobile = this.deviceDetector.isMobile();
    this.blogs = fields?.result?.Blogs;

    if(!this.rendering?.fields?.SelectedCategory) super.ngOnInit();
  }

  getBlog(){
    // call api
    var request = {
      PageId: (this.rendering.fields?.result as any)?.BlogMainPage?.CategoryPage.ID,
      Category: this.rendering?.fields?.SelectedCategory ? (this.rendering?.fields?.SelectedCategory as  any)?.id : "",
      Tag: (this.rendering?.fields?.result as any )?.SelectedTag ? (this.rendering?.fields?.result as any )?.SelectedTag.ID : "",
      Skip: this.blogs.length,
      PageSize: 5
    }

    this.apiService.fetch<any>("/piraeusapi/articles/blog/getblogs", request ).
      then(resp => {
        if (resp.status === 200) {
          this.blogs = this.blogs.concat(resp.data);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.contextSubscription) {
      this.contextSubscription.unsubscribe();
    }
  }

}
